export const proyects = [
	{
		id: 1,
		title: 'Countries',
		subtitle: 'App Fullstack basada en Countries.',
		description:
			'Diseño y desarrollo de una SPA basada en Países. La aplicación cuenta con un listado de países, ordenamiento, filtrado, búsqueda y formulario de creación de actividades.',

		imageUrl: 'https://res.cloudinary.com/dyimla3kt/image/upload/v1664832419/portfolio/cli_ls5bkf.png',
		imagesUrl: [
			{
				id: '1',
				title: 'Landing page',
				url: 'https://res.cloudinary.com/dyimla3kt/image/upload/v1664832419/portfolio/cli_ls5bkf.png',
			},
			{
				id: '2',
				title: 'Listado de países',
				url: 'https://res.cloudinary.com/dyimla3kt/image/upload/v1664832416/portfolio/cli-1_jziti3.png',
			},
			{
				id: '3',
				title: 'Detalle de un país',
				url: 'https://res.cloudinary.com/dyimla3kt/image/upload/v1664832417/portfolio/cli-4_lmoxbh.png',
			},
			{
				id: '4',
				title: 'Formulario de creación de actividad',
				url: 'https://res.cloudinary.com/dyimla3kt/image/upload/v1664832420/portfolio/cli-5_tfmf4z.png',
			},
		],
		tech: ['ReactJs', 'React-redux', 'NodeJs', 'ExpressJs', 'Sequelize', 'PostgreSQL', 'CSS'],
		repository: 'https://github.com/joelorzet/countries-client',
		deploy: 'https://countries-app-joelorzet.vercel.app',
		role: 'Diseño y desarrollo',
		contribution: '',
	},
	{
		id: '2',
		title: 'Ecommerce Sehos',
		subtitle: 'App para administrar un E-commerce',
		description:
			'Colaborador de una SPA fullstack, basada en un e-commerce de zapatos. Cuenta con: login/register, autenticación de usuarios, listado de productos, filtrados, ordenamientos, dashboard de administrador con funcionalidades de gestión de la tienda, panel de usuario para administrar tu cuenta y pasarela de pagos online.',
		imageUrl: 'https://res.cloudinary.com/dg84upfsp/image/upload/v1664077398/cld-sample-5.jpg',
		imagesUrl: [
			{
				id: '1',
				title: 'Landing page de bienvenida',
				url: 'https://res.cloudinary.com/dg84upfsp/image/upload/v1664143414/PORTFOLIO/0_vmrstv.jpg',
			},
			{
				id: '2',
				title: 'Listado de productos',
				url: 'https://res.cloudinary.com/dg84upfsp/image/upload/v1664143414/PORTFOLIO/1_lnhvrw.jpg',
			},
			{
				id: '3',
				title: 'Historial de ordenes',
				url: 'https://res.cloudinary.com/dg84upfsp/image/upload/v1664143414/PORTFOLIO/2_ooxuf7.jpg',
			},
			{
				id: '4',
				title: 'Detalle de cada Orden',
				url: 'https://res.cloudinary.com/dg84upfsp/image/upload/v1664143414/PORTFOLIO/3_qhwole.jpg',
			},
			{
				id: '5',
				title: 'Administrador de direcciones de entrega',
				url: 'https://res.cloudinary.com/dg84upfsp/image/upload/v1664143414/PORTFOLIO/4_rra6yv.jpg',
			},
			{
				id: '6',
				title: 'Listado de productos favoritos',
				url: 'https://res.cloudinary.com/dg84upfsp/image/upload/v1664143415/PORTFOLIO/5_t3pmuq.jpg',
			},
			{
				id: '7',
				title: 'Actualizar perfil de usuario',
				url: 'https://res.cloudinary.com/dg84upfsp/image/upload/v1664143414/PORTFOLIO/6_sxotgz.jpg',
			},
			{
				id: '8',
				title: 'Detalle de los productos',
				url: 'https://res.cloudinary.com/dg84upfsp/image/upload/v1664143414/PORTFOLIO/7_j5ecs0.jpg',
			},
			{
				id: '9',
				title: 'Sistema de Reviews',
				url: 'https://res.cloudinary.com/dg84upfsp/image/upload/v1664143414/PORTFOLIO/8_kbjcbv.jpg',
			},
		],
		tech: [
			'ReactJs',
			'Redux-Toolkit',
			'Material/UI',
			'ExpressJs',
			'NodeJs',
			'Sequelize',
			'PostgreSQL',
			'Typescript',
		],
		repository: 'https://github.com/joelorzet/sehos-client',
		deploy: 'https://sehos.netlify.app/',
		role: 'Diseño y desarrollo',
		contribution:
			'Entre mis contribuciones mas importantes estan: Inicio de sesión con cuenta de terceros, configuración de paleta de colores en Material UI, reseteo de password, búsqueda de productos, validación de rutas y protección de las mismas según el rol del usuario.',
	},
];
